import { observer } from "mobx-react";
import { NoAuditorForm } from "./noAuditorDomain";
import { Alert } from "@/components-v2/Alert";
import { useState } from "react";
import { LinkButton } from "@/components-v2/Button";
import { Box } from "@/components-v2/Box";

import { useTranslation } from "@/stores/RootStoreContext";

export const NoAuditorFormView = observer(function NoAuditorFormView({
  form,
}: {
  form: NoAuditorForm;
}) {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const missing = form.companiesWithoutAuditor;
  return form.allCompaniesHaveAuditor ? (
    <div>
      {showMore ? (
        <div className={"content"}>
          <div>{t("decisionType.noAuditor.text")}</div>
          <Box paddingTop={"sm"}>{t("kindly_note")}</Box>
          <Box paddingLeft={"md"} paddingTop={false}>
            <ul>
              <li>{t("decisionType.noAuditor.text.li1")}</li>
              <li>{t("decisionType.noAuditor.text.li2")}</li>
            </ul>
          </Box>
          <LinkButton label={t("list.showLess")} onClick={() => setShowMore(false)} />
        </div>
      ) : (
        <div>
          {t("decisionType.noAuditor.text").slice(0, 40)}
          {"..."}
          <LinkButton label={t("list.showMore")} onClick={() => setShowMore(true)} />
        </div>
      )}
    </div>
  ) : (
    <div>
      <Alert
        message={t({
          key: "decisionType.noAuditor.companyHasNoAuditor",
          params: {
            count: missing.length,
            companies: { type: "list", value: missing.map((c) => c.name) },
          },
        })}
        type={"error"}
      />
    </div>
  );
});
